import { createActionCreator } from '@pressreader/appstore';
import { IPoint } from '@pressreader/geometry';

import { MODULE_NAME } from '../constants';

const prefix = `${MODULE_NAME}/`;

export const navigateToTagAction = createActionCreator<{
    tagId: number;

    /** SEO slug for the "/topics/{slug}-{id}" route; without it (or with the route disabled) navigation falls back to "/category/tag-{id}". */
    slug?: string | null;

    locale?: {
        country: string;
        lang: string;
    };

    articleId?: string;
}>(`${prefix}navigate-to-tag`);

export const navigateToIssuePageAction = createActionCreator<{ issueKey: string; pageNumber: number }>(`${prefix}navigate_to_issue_page`);

export const openIssuePageMenuAction = createActionCreator<{
    issueKey: string;
    pageNumber: number;
    center: IPoint;
}>(`${prefix}open_issue_page_menu`);

export const exitPublicationAction = createActionCreator(`${prefix}exit-publication`);

export const navigateToArticleInCurrentPageViewAction = createActionCreator<{ issueKey: string; articleId: string }>(
    `${prefix}navigate-to-article-in-current-pageview-action`,
);
